var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "modal",
    {
      attrs: {
        title: _vm.$t("teacher.test_student_modal_header"),
        "backbone-dismiss-modal": true,
      },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { attrs: { id: "test-student-modal" } }, [
        _c(
          "div",
          { staticClass: "modal-body" },
          [
            _c("p", [
              _vm._v(" " + _vm._s(_vm.$t("teacher.test_student_modal_p1"))),
            ]),
            _vm._v(" "),
            _vm.classLoading
              ? [_c("p", [_vm._v(_vm._s(_vm.$t("common.loading")))])]
              : [
                  _vm.classrooms.length
                    ? [
                        _c("span", { staticClass: "bold-span" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("teacher.test_student_modal_choose_class")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.classCode,
                                expression: "classCode",
                              },
                            ],
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.classCode = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.classrooms, function (classroom) {
                            return _c(
                              "option",
                              {
                                key: classroom.code,
                                domProps: { value: classroom.code },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(classroom.name) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    : [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("teacher.test_student_modal_no_class")
                            )
                          ),
                        ]),
                      ],
                ],
            _vm._v(" "),
            _c("p", { staticClass: "small-p" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("teacher.stop_spying_student")) +
                  "\n      "
              ),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _vm.classCode
          ? _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                { staticClass: "dusk-btn", on: { click: _vm.joinClassroom } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.continue")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "small-font" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("teacher.test_student_modal_redirect")) +
                    "\n      "
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }